import { createFileRoute, redirect } from '@tanstack/react-router'
import { adminApiClient } from '@/lib/admin-api-client'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    try {
      const response = await adminApiClient('/auth/me')
      if (response.ok) {
        throw redirect({ to: '/dashboard' })
      } else {
        throw redirect({ to: '/login' })
      }
    } catch (error) {
      // If it's already a redirect, re-throw it
      if (error && typeof error === 'object' && 'to' in error) throw error
      throw redirect({ to: '/login' })
    }
  },
})
